import PropertyVideoListContainer from "../../../components/property/listing/PropertyVideoList";

const PropertyVideoList = () => {
  return <PropertyVideoListContainer />;
};

export default PropertyVideoList;
